import React, { useState, useEffect } from "react";

export default function DiarioIframeResponsive() {
  const SHEET_IFRAME =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQvHDTPxxnxeLJic84NsfhfVfPC0aH63ohkaoUQ-mhIhfs7phnWBG0pf0601MHAOazbVTHO8Z_hFm-n/pubhtml?widget=true&headers=false";

  // Estado para altura responsive del iframe
  const [iframeHeight, setIframeHeight] = useState(650);

  useEffect(() => {
    // Función para ajustar altura según el ancho de la pantalla
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) setIframeHeight(400);   // móviles
      else if (width < 1024) setIframeHeight(550); // tablets
      else setIframeHeight(650);               // desktop
    };

    handleResize(); // inicial
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="bg-gray-900 min-h-screen p-6 text-white flex flex-col items-center">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Diario de Operaciones — 2026
      </h1>

      <section className="text-center max-w-3xl mx-auto mb-8">
        <p className="text-xl text-gray-300">
          "Enfocarse en el largo plazo es entender que cada operación es solo un
          dato dentro de tu ventaja estadística."
        </p>
        <span className="text-gray-400">— Domingo Del Rosario</span>
      </section>

      {/* Contenedor responsive con scroll */}
      <div
        className="w-full max-w-full border border-gray-600 rounded-xl overflow-auto"
        style={{ paddingBottom: "40px" }} // para no cortar pestañas
      >
        <iframe
          title="Diario de Operaciones"
          src={SHEET_IFRAME}
          width="100%"
          height={iframeHeight}
          style={{ border: "none", display: "block" }}
        ></iframe>
      </div>

      <p className="text-gray-400 text-sm mt-4 text-center">
        Usa el scroll para ver más filas. Las pestañas de todos los meses se ven
        abajo y puedes cambiarlas directamente.
      </p>
    </div>
  );
}

